/*eslint-disable */
import axios from 'axios';
import toast from './toast'
import store from '../store/store';
import router from '../route';

// Interceptor
axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
  let errorcode = error.response.data;
    if(errorcode != undefined){
        if(error.response.status == 400 || error.statusText == 'Bad Request'){
          if(error.response.data.code == 1000){
            if(error.response.data.data.email){
              toast.error(error.response.data.data.email[0], 'Email');
            } else if(error.response.data.data.password){
              toast.error(error.response.data.data.password.msg, 'Password');
            } else if(error.response.data.data.profile.mobile){
              toast.error(error.response.data.data.profile.mobile[0], 'Mobile');
            }else{
              toast.error('something goes wrong, Try again later')
            } 
          } else if(error.response.data.non_field_errors){
            toast.error(error.response.data.non_field_errors);
          }
        }
        if (error.response.status == 401 ||  error.statusText == 'Unauthorized') {
          toast.error('Your session expired, please login again');
          store.dispatch('logout'); 
           router.push('/');
        }
        if (error.response.status == 403 || error.response.data.code == 8003) {
              // console.log(error.response.data.code)
              toast.error(error.response.data.msg);
              store.dispatch('logout');
              router.push('/');
          }
        if(error.response.status == 415){
          toast.error('Media not supported');
        }
        return Promise.reject(error.response);
    }else{

    }
});